import { render, staticRenderFns } from "./tooltipBgc.vue?vue&type=template&id=9e539538&scoped=true"
import script from "./tooltipBgc.vue?vue&type=script&lang=js"
export * from "./tooltipBgc.vue?vue&type=script&lang=js"
import style0 from "./tooltipBgc.vue?vue&type=style&index=0&id=9e539538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e539538",
  null
  
)

export default component.exports